import {defineMessages} from 'react-intl';

const messages = defineMessages({
  cancel: {
    id: 'common.actions.cancel',
    defaultMessage: 'Cancel'
  },
  selectFile: {
    id: 'MediaUploader.selectFile',
    defaultMessage: 'Select an image or video from your library or using the camera on your device'
  },
  uploadingFile: {
    id: 'MediaUploader.uploadingFile',
    defaultMessage: 'Uploading file...'
  }
});

export default messages;
